"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.einsteinPalette = void 0;

/**
 * A Palette of colors for data visualizations
 */
var einsteinPalette = {
  einstein10: '#EFF5DD',
  einstein30: '#E3EEBD',
  einstein60: '#CFE57E',
  einstein: '#B9D340',
  einsteinDark: '#8C9F34',
  einsteinDarkest: '#5A6C06'
};
exports.einsteinPalette = einsteinPalette;